<template>
    <div id="app" :class="$route.name">
        <div v-if="loading" class="loadding-overlay">
            <div class="loadding-icn"></div>
        </div>
        <div class="app-progressbar-pc">
            <progressbar :current="mazlicek.step.current" :max="mazlicek.step.max"></progressbar>
        </div>
        <div class="app-content">
            <div class="app-content-left">
                <router-view keep-alive></router-view>
            </div>

            <div class="app-content-right">
                <div v-if="$store.state.mazlicek.step.current < 9">
                    <right-content-header></right-content-header>
                    <checklist></checklist>
                </div>
                <div v-else>
                    <div class="final-step-tabs">
                        <div class="final-step-tabs-content">
                            <div :class="{'final-step-tab' : true, 'active' : activeTab == 0}" @click="activeTab = 0">
                                Objednávka
                            </div>
                            <div :class="{'final-step-tab' : true, 'active' : activeTab == 1}" @click="activeTab = 1">
                                Shrnutí
                            </div>
                        </div>
                    </div>
                    <div>
                        <order v-show="activeTab == 0"></order>
                        <checklist @activeTab="activeTab = 0" v-show="activeTab == 1"></checklist>
                    </div>
                </div>
<!--                <div v-if="isLoggedIn" >-->
<!--                    <a @click="saveAndRedirect('/prihlaseni')">Uložit a přejít do profilu</a>-->
<!--                </div>-->
            </div>
        </div>
        <div class="app-progressbar-mobile">
            <progressbar :current="mazlicek.step.current" :max="mazlicek.step.max"></progressbar>
        </div>

    </div>
</template>

<script>
    import Store from './vuex/store'
    import progressbar from './components/ProgressBar'
    import checklist from './components/Checklist'
    import order from './components/Order'
    import {apiDrupal} from './api/index'
    import RightContentHeader from './components/RightContentHeader'
    import moment from 'moment'
    import imageService from './services/image-service'
    import {apiSilex} from './api'

    export default {
        name: 'app',
        //store: Store,
        components: {
            progressbar,
            checklist,
            order,
            'right-content-header': RightContentHeader
        },
        data: function () {
            return {
                activeTab: 0,
                mazlicek: this.$store.state.mazlicek,
                stepsUrl: {
                    '1': 'jmenomazlicka',
                    '2': 'rasa',
                    // '3': 'fotografie',
                    '3': 'narozeniny',
                    '4': 'pohlavi',
                    '5': 'hmotnostkondice',
                    '6': 'pohyb',
                    '7': 'alergie',
                    '8': 'suroviny',
                    '9': 'hotovekrmivo'
                },
                // isLoggedIn: false,
                test: null,
                router: this.$router
            }
        },
        computed: {
            loading() {
                return this.$store.state.loading
            }
        },
        methods: {
            setPet(nodePet) {
                this.test = nodePet
                let mazlicek = nodePet

                if (!mazlicek.nid) return

                this.$store.state.mazlicek.nid = Number(mazlicek.nid)

                this.$store.state.mazlicek.jmeno.value = mazlicek.title
                this.$store.state.mazlicek.jmeno.valid = true

                if (mazlicek.field_mazlicek_ref_rasa.und) {
                    this.$store.state.mazlicek.rasa.typ = 'app_rasa'
                    this.$store.state.mazlicek.rasa.id = mazlicek.field_mazlicek_ref_rasa.und[0].value
                    this.$store.state.mazlicek.rasa.autocomplete.keyword = mazlicek.field_mazlicek_ref_rasa.und[0].data.nazev_cj
                } else if (mazlicek.field_mazlicek_ref_velikost.und) {
                    this.$store.state.mazlicek.rasa.typ = 'app_velikost'
                    this.$store.state.mazlicek.rasa.velikost = mazlicek.field_mazlicek_ref_velikost.und[0].value
                }
                if(mazlicek.size_price_ratio){
                  this.$store.state.mazlicek.rasa.priceRatio = mazlicek.size_price_ratio
                }
                this.$store.state.mazlicek.rasa.valid = true

                // if (mazlicek.field_mazlicek_obrazek.und
                //   && mazlicek.field_mazlicek_obrazek_original.und
                //   && mazlicek.field_mazlicek_cropp_settings.und) {
                //     this.$store.state.mazlicek.fotografie.typ = 'foto'
                //     if(mazlicek.field_mazlicek_obrazek.und[0].photoBase64){
                //       this.$store.state.mazlicek.fotografie.value = mazlicek.field_mazlicek_obrazek.und[0].photoBase64
                //     }
                //     // this.$store.state.mazlicek.fotografie.original = mazlicek.field_mazlicek_obrazek_original.und[0].photoBase64
                //     // sessionStorage.setItem('petPhotoTimestamp', mazlicek.field_mazlicek_obrazek.und[0].timestamp)
                //     this.$store.state.mazlicek.fotografie.timestamp = mazlicek.field_mazlicek_obrazek.und[0].timestamp
                //     this.$store.state.mazlicek.fotografie.url = mazlicek.field_mazlicek_original_img_url.und[0].value + '?tok=' + Date.now()
                //     this.$store.state.mazlicek.fotografie.cropOptions = mazlicek.field_mazlicek_cropp_settings.und[0].value
                //
                //     this.$store.state.mazlicek.fotografie.valid = true
                // } else
                // if (mazlicek.field_mazlicek_valid_fotografie.und && mazlicek.field_mazlicek_valid_fotografie.und[0].value == 1) {
                    this.$store.state.mazlicek.fotografie.typ = 'ikona'
                    this.$store.state.mazlicek.fotografie.valid = true
                // }

                if (mazlicek.field_mazlicek_datum_narozeni.und) {
                    this.$store.state.mazlicek.narozeniny.value = moment(mazlicek.field_mazlicek_datum_narozeni.und[0].iso)
                    this.$store.state.mazlicek.narozeniny.valid = true
                }

                if (mazlicek.field_mazlicek_je_stene.und) {
                    this.mazlicek.jeStene = mazlicek.field_mazlicek_je_stene.und[0].value == '1'
                }

                if (mazlicek.field_mazlicek_pohlavi.und) {
                    this.$store.state.mazlicek.pohlavi.value = mazlicek.field_mazlicek_pohlavi.und[0].value
                    this.$store.state.mazlicek.pohlavi.valid = true
                    this.$store.state.mazlicek.pohlavi.laktujici = Boolean(Number(mazlicek.field_mazlicek_laktujici.und[0].value))
                }

                if (mazlicek.field_mazlicek_hmotnost.und) {
                    this.$store.state.mazlicek.hmotnostkondice.hmotnost = mazlicek.field_mazlicek_hmotnost.und[0].value
                    if (!this.mazlicek.jeStene)
                        this.$store.state.mazlicek.hmotnostkondice.kondice = mazlicek.field_mazlicek_ref_kondice.und[0].value
                    this.$store.state.mazlicek.hmotnostkondice.valid = true
                }

                if (mazlicek.field_mazlicek_ref_aktivita.und && !this.mazlicek.jeStene) {
                    this.$store.state.mazlicek.pohyb.value = mazlicek.field_mazlicek_ref_aktivita.und[0].value
                    this.$store.state.mazlicek.pohyb.id = mazlicek.field_mazlicek_ref_aktivita.und[0].value
                    this.$store.state.mazlicek.pohyb.valid = true
                }

                if (mazlicek.field_mazlicek_ref_alergie.und && mazlicek.field_mazlicek_je_alergik.und && mazlicek.field_mazlicek_je_alergik.und[0].value == 1) {
                    this.$store.state.mazlicek.alergie.alergie = mazlicek.field_mazlicek_ref_alergie.allergens.length > 0
                    this.$store.state.mazlicek.alergie.valid = true
                    this.$store.state.mazlicek.alergie.alergeny = mazlicek.field_mazlicek_ref_alergie.allergens
                }

                if (mazlicek.field_mazlicek_je_alergik.und && mazlicek.field_mazlicek_je_alergik.und[0].value == 0) {
                    this.$store.state.mazlicek.alergie.alergie = false
                    this.$store.state.mazlicek.alergie.valid = true
                }

                if (mazlicek.field_mazlicek_pref_weight_unit.und)
                    this.$store.state.mazlicek.hmotnostkondice.hmotnostJednostka = mazlicek.field_mazlicek_pref_weight_unit.und[0].value

                // NOTE: Je to tu z důvodu aby se aktualizoval state
                let storeMazlicek = this.$store.state.mazlicek
                this.$store.commit('setMazlicek', storeMazlicek)

                if (this.mazlicek.rasa.id) {
                    apiSilex.get('/rasa?id=' + this.mazlicek.rasa.id).then((response) => {
                        const val = response.data[0]

                        const raceImage = val.rasa_obrazek_url !== ""  ?
                            val.rasa_obrazek_url : imageService.RACE_ORIGINAL_IMAGES_URL + val.title_en + '.png'

                        this.mazlicek.fotografie.icnValue = raceImage
                    })
                } else {
                    // const raceImage = imageService.SIZE_ORIGINAL_IMAGES_URL + 'size-' + this.mazlicek.rasa.velikost + '.png'
                    const raceImage = imageService.SIZE_ORIGINAL_IMAGES_URL + 'size-new-' + this.mazlicek.rasa.velikost + '.svg'

                    this.mazlicek.fotografie.icnValue = raceImage
                }

                if (mazlicek.order_data) {
                    this.mazlicek.orderData.activeSubscription = mazlicek.order_data.active_subscription
                    this.mazlicek.orderData.isFirstOrderSent = mazlicek.order_data.is_first_order_sent
                    this.mazlicek.orderData.orderSendDate = mazlicek.order_data.order_send_date
                }

                this.mazlicek.petLoaded.value = true
                this.$store.commit('setMazlicek', this.mazlicek)

//                if(this.$route.name !== this.stepsUrl[this.mazlicek.step.current]) {


                let redirectIndex = this.getValidIndex()
//                this.$router.push({name: this.stepsUrl[redirectIndex]});
//                }
            },

            setProduct(data) {
                let feedData = data.feedData
                let krmivo = data.node

                if (!krmivo.nid) return

                this.$store.state.mazlicek.orderData.isFirstOrder = krmivo.order_data.is_first_order
                this.$store.state.mazlicek.orderData.firstOrderPrice = krmivo.order_data.first_order_price

                this.$store.state.mazlicek.krmivo.feedData = feedData

                //NOTE: Jeden produkt je k jednomu mazlíčkovi, v dalších krocích objednávky se produkt
                // rozkopíruje a tento typ obsahu se již nepoužívá.

                this.$store.state.mazlicek.krmivo.nid = krmivo.nid
                // console.log(krmivo)

                if (krmivo.field_produkt_ref_suroviny && krmivo.field_produkt_ref_suroviny.und) {
                    if (krmivo.field_produkt_ref_suroviny.und[3] && krmivo.field_produkt_ref_suroviny.und[3]['value']) {
                        krmivo.field_produkt_ref_suroviny.und[3].value.split(',').forEach(
                            item => this.$store.state.mazlicek.krmivo.selectedAdditions.push(item)
                        )
                        this.$store.state.mazlicek.suroviny.slozky[4] = krmivo.field_produkt_ref_suroviny.und[3].value
                    }
                    for (let i = 0; i < krmivo.field_produkt_ref_suroviny.und.length; i++) {
                        let surovina = krmivo.field_produkt_ref_suroviny.und[i]
                        if (i != 3 && i != 2) {
                            this.$store.state.mazlicek.suroviny.slozky[surovina.data.id_typ_slozky] = surovina.value
                        }
                        if (i == 2) {
                            this.$store.state.mazlicek.suroviny.slozky[3] = 0
                        }
                    }
                    //this.$store.state.mazlicek.suroviny.suroviny = []
                    this.$store.state.mazlicek.suroviny.valid = true
                }
                if (krmivo.field_produkt_addition_services && krmivo.field_produkt_addition_services.und) {
                    krmivo.field_produkt_addition_services.und.forEach(
                        item => this.$store.state.mazlicek.krmivo.aditionalServices.push(item.value)
                    )
                }
                // console.log(krmivo);
                // this.$store.state.mazlicek.krmivo.tydny.value = krmivo.field_produkt_pocet_tydnu['und'][0]['value']
                // console.log(this.$store.state.mazlicek);
//                //NOTE: Je to tu z důvodu aby se aktualizoval state

                this.mazlicek = this.$store.state.mazlicek
//                mazlicek.step.current = 10

                this.$store.commit('setMazlicek', this.mazlicek)

                this.$store.dispatch('updateProduct', this.mazlicek).then(response => {
                    this.mazlicek.krmivo.feedData = response.data.data.feedData
                    this.mazlicek.krmivo.cena.den = this.mazlicek.krmivo.feedData.feedRatio.totalPrice
                    this.$store.commit('setMazlicek', this.mazlicek)
                    this.mazlicek = this.mazlicek
                    this.mazlicek.productLoaded.value = true
                    this.$store.commit('setMazlicek', this.mazlicek)
                    this.$store.commit("setLoading", false)
//                    this.$router.push({name: 'hotovekrmivo'})
                })
            },
            getValidIndex() {
                if (!this.mazlicek.jmeno.valid)
                    return 1;

                if (!this.mazlicek.rasa.valid)
                    return 2;

                if (!this.mazlicek.rasa.valid)
                    return 2;

                if (!this.mazlicek.narozeniny.valid)
                    return 4;

                if (!this.mazlicek.pohlavi.valid)
                    return 5;

                if (!this.mazlicek.hmotnostkondice.valid)
                    return 6;

                if (!this.mazlicek.pohyb.valid)
                    return 7;

                if (!this.mazlicek.alergie.valid)
                    return 8;

                if (!this.mazlicek.alergie.valid)
                    return 9;

                if (!this.mazlicek.suroviny.valid)
                    return 10;

                return 1;
            },
            getRouteById(index) {
                return this.stepsUrl[index]
            },
            // saveAndRedirect(path) {
            //   var component = this.$router.currentRoute.matched[0].components.default
            //   console.log(component)
            //   component.methods.next()
            //   // window.location.href = path
            // }
        },

        mounted() {
//            if (window.konfigurator.step) {
//                this.$router.push({name: this.getRouteById(window.konfigurator.step)})
//            } else {
////                let lastVisitedStep = this.$localStorage.get('lastVisitedStep')
//                let lastVisitedStep = this.$cookies.get('lastVisitedStep')
//                lastVisitedStep = lastVisitedStep > 0 ? lastVisitedStep : 1
//                console.log(lastVisitedStep)
//                this.$router.push({name: this.getRouteById(lastVisitedStep)})
//            }
            if (window.konfigurator && window.konfigurator.pet_nid) {
                let url = '/pet/' + window.konfigurator.pet_nid
                // const ts = sessionStorage.getItem('petPhotoTimestamp')
                // if(ts) {
                //     url += '?timestamp=' + ts
                // } else if(this.$store.state.mazlicek.fotografie.value) {
                //     url += '?timestamp=0'
                // }
                // console.log(url)
                apiDrupal.get(url)
                    .then(response => {
                        this.test = response.data.data
                        this.setPet(response.data.data)
                        if (window.konfigurator.feed_nid) {
                            apiDrupal.get('/product/' + window.konfigurator.feed_nid)
                                .then(response => this.setProduct(response.data.data))
                                .catch(err => console.error(err))
                        } else if (sessionStorage.feed_nid) {
                            apiDrupal.get('/product/' + sessionStorage.feed_nid)
                                .then(response => this.setProduct(response.data.data))
                                .catch(err => console.error(err))
                        }
                    })
            } else if (sessionStorage.pet_nid && this.$route.name == 'hotovekrmivo') {
                this.$store.commit("setLoading", true)
                apiDrupal.get('/pet/' + sessionStorage.pet_nid)
                    .then(response => {
                        this.test = response.data.data
                        this.setPet(response.data.data)
                        if (sessionStorage.feed_nid) {
                            apiDrupal.get('/product/' + sessionStorage.feed_nid)
                              .then(response => this.setProduct(response.data.data))
                              .catch(err => console.error(err))
                        }
                    })
            }
        },
        watch: {
            'mazlicek.step.current': {
                deep: true,
                handler: function (val) {
                    if (val === 9) {
                        this.activeTab = 0
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// App.vue?6d66e5ee